import type { IconData } from '@stacksjs/iconify-core'

export const logoSocialMediaYoutube: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 9.14H32v13.72h-1.53Zm-1.52 13.72h1.52v1.52h-1.52Zm0-15.24h1.52v1.52h-1.52Zm-1.53 16.76h1.53v1.52h-1.53Zm0-18.29h1.53v1.53h-1.53Z\"/><path fill=\"currentColor\" d=\"M27.42 7.62H4.57v1.52H3.04v13.72h1.53v1.52h22.85v-1.52h1.53V9.14h-1.53Zm-7.61 9.14h-1.53v1.53h-1.52v1.52h-3.05v1.52h-1.52V10.67h1.52v1.52h3.05v1.52h1.52v1.53h1.53ZM4.57 25.9h22.85v1.53H4.57Zm0-21.33h22.85v1.52H4.57ZM3.04 24.38h1.53v1.52H3.04Zm0-18.29h1.53v1.53H3.04ZM1.52 22.86h1.52v1.52H1.52Zm0-15.24h1.52v1.52H1.52ZM0 9.14h1.52v13.72H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default logoSocialMediaYoutube
